import { render, staticRenderFns } from "./Airticketorderdetails.vue?vue&type=template&id=67b4ff1d&scoped=true"
import script from "./Airticketorderdetails.vue?vue&type=script&lang=js"
export * from "./Airticketorderdetails.vue?vue&type=script&lang=js"
import style0 from "./Airticketorderdetails.vue?vue&type=style&index=0&id=67b4ff1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b4ff1d",
  null
  
)

export default component.exports